exports.calculateLastAssessment = (date) => {
  let seconds = Math.floor((new Date() - new Date(date)) / 1000);
  let interval = Math.floor(seconds / 31536000);
  if (interval === 1) {
    return `${interval} Year Ago`;
  } else if (interval > 1) {
    return `${interval} Years Ago`;
  }

  interval = Math.floor(seconds / 2592000);
  if (interval === 1) {
    return `${interval} Month Ago`;
  } else if (interval > 1) {
    return `${interval} Months Ago`;
  }

  interval = Math.floor(seconds / 86400);
  if (interval === 1) {
    return "Yesterday";
  } else if (interval > 1) {
    return `${interval} Days Ago`;
  }

  interval = Math.floor(seconds / 3600);
  if (interval === 1) {
    return "1 Hour Ago";
  } else if (interval > 1) {
    return `${interval} Hours Ago`;
  }

  interval = Math.floor(seconds / 60);
  if (interval === 1) {
    return "1 Minute Ago";
  } else if (interval > 1) {
    return `${interval} Minutes Ago`;
  }

  if (seconds === 1) {
    return "1 Second Ago";
  } else {
    return `${seconds} Seconds Ago`;
  }
};

exports.convertDateFormat = (patientDob) => {
  const dob = new Date(patientDob);
  let dobYear = dob.getFullYear();
  let dobMonth = dob.getMonth() + 1;
  if (dobMonth < 10) {
    dobMonth = `0${dobMonth}`;
  }
  let dobDate = dob.getDate();
  if (dobDate < 10) {
    dobDate = `0${dobDate}`;
  }
  return `${dobMonth}/${dobDate}/${dobYear}`;
};

const MonthMapping = {
  "01": "Jan",
  "02": "Feb",
  "03": "Mar",
  "04": "Apr",
  "05": "May",
  "06": "Jun",
  "07": "Jul",
  "08": "Aug",
  "09": "Sep",
  10: "Oct",
  11: "Nov",
  12: "Dec",
};

let dateMap = (date) => {
  date = date.split("-");
  let day = date[2];
  let month = date[1];
  let year = date[0];
  return {
    day,
    month,
    year,
  };
};

exports.formatDate = (date) => {
  date = dateMap(date);
  return `${date.month}/${date.day}/${date.year}`;
};
exports.formatDateShortMonthName = (date) => {
  date = dateMap(date);
  return `${MonthMapping[date.month]} ${date.day}, ${date.year}`;
};
